enum ExternalSupplier {
  WeGift = "Wegift",
  DigitalGlue = "Digital Glue",
  Meritgc = "Meritgc"
}

export default ExternalSupplier
